<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-form
                v-if="data"
                ref="form"
                v-model="form"
                @submit.prevent="submitForm"
            >
                <v-card-title style="background-color: #009688; color: white;">
                    Delete Diagnostic: &nbsp;<v-chip>{{ data.DIA_T }}</v-chip>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model.trim="data.DIA_T"
                        label="Diagnostic"
                        readonly
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        width="120"
                        @click="showDialog = false"
                    >
                        <v-icon small>
                            {{ mdiClose }}
                        </v-icon>
                        Close
                    </v-btn>
                    <v-btn
                        color="teal darken-1"
                        width="120"
                        style="color: white;"
                        type="submit"
                    >
                        <v-icon small>
                            {{ mdiTrashCan }}
                        </v-icon>
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiClose,
    mdiTrashCan
} from '@mdi/js'
export default {
    props: ['show', 'data', 'notif'],
    data: ()=>({
        mdiClose,
        mdiTrashCan,
        form: false
    }),
    computed: {
        ...mapGetters(['deletePackageDiagnosticData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        deletePackageDiagnosticData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Diagnostic has been deleted.'
                    this.notif.show = true
                    this.getPackageDiagnostics({ RATE_ID: this.data.RATE_ID })
                    this.showDialog = false
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        }
    },
    methods: {
        ...mapActions(['deletePackageDiagnostic', 'getPackageDiagnostics']),
        submitForm() {
            if (this.$refs.form.validate()) {
                const arg = {
                    ID : this.data.ID,
                    RATE_ID: this.data.RATE_ID
                }
                this.deletePackageDiagnostic(arg)
            }
        }
    }
}
</script>
